import { Component, OnInit } from '@angular/core';
import { NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { SignupWizardService } from '../signup-wizard.service';

@Component({
  standalone: false,
  selector: 'sbnb-signup-properties',
  templateUrl: './signup-properties.component.html',
  styleUrls: ['./signup-properties.component.scss'],
})
export class SignupPropertiesComponent implements OnInit {
  propertiesCount: number;
  saving: boolean;

  constructor(
    private wizard: SignupWizardService,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit() {
    if (!this.wizard.signupUser.token) {
      this.wizard.cancel();
    }

    this.propertiesCount = this.wizard.signupUser.property_count;
  }

  next() {
    this.saving = true;

    if (!Number.isInteger(+this.propertiesCount)) {
      this.toast.open(
        'Please enter a number for the number of properties you manage.',
        'Dismiss',
        NotificationType.Error
      );

      this.saving = false;
      return;
    }

    this.wizard.updatePropertyCount(this.propertiesCount).subscribe(
      (res) => {
        this.saving = false;
        this.wizard.next();
      },
      () => {
        this.saving = false;
      }
    );
  }
}
